import { Dialog } from '@mui/material'
import { useRef } from 'react'

import analytics from '@src/analytics'
import { useRefinerSurvey } from '@src/lib/useRefinerSurvey'

import IGAutomation, { IGAutomationImperativeRef } from './IGAutomation'

interface IGAutomationDialogProps {
  open: boolean
  onClose: () => void
}

const IGAutomationDialog: React.FC<
  React.PropsWithChildren<IGAutomationDialogProps>
> = ({ open, onClose }) => {
  const ref = useRef<IGAutomationImperativeRef | null>(null)
  const { refiner } = useRefinerSurvey()

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        const values = ref.current?.()

        if (reason && !values?.retailerHasNoFacebookPages) {
          analytics.track({
            event: 'Click',
            type: 'Clicked Or Escaped Out Of IG Automation Form Without Submitting',
            data: {
              source: 'Billboard',
              feature: 'IG Auto Share',
            },
          })
        }

        if (
          reason &&
          !values?.retailerHasNoFacebookPages &&
          values?.initialSelectedInstagramAutomations.length === 0
        ) {
          refiner('showForm', 'why-no-ig-autoshare')
        }

        onClose()
      }}
    >
      <IGAutomation onClose={onClose} ref={ref} />
    </Dialog>
  )
}

export default IGAutomationDialog
